import { render } from "./MyTransactions.vue?vue&type=template&id=235792e4&scoped=true"
import script from "./MyTransactions.vue?vue&type=script&lang=js"
export * from "./MyTransactions.vue?vue&type=script&lang=js"

import "./MyTransactions.vue?vue&type=style&index=0&id=235792e4&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235792e4"]])

export default __exports__